import React, {useState,useEffect} from 'react';
import MenuSupport from "./MenuSupport";
import SupportWork from "./SupportWork";
import { Menu,Table, Button, Space, Spin } from 'antd';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import axios from "axios";




/**
 * Функциональный компонент, который отображает новые сообщение с поддержку которые не были приняты
 */
export default function ChangeStatus() {



    return(
        <div className={'tablename'}>
            
        </div>
    )


}

